import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/elementErrors';

// eslint-disable-next-line import/prefer-default-export
export const addErroneousElement = createAction(types.ADD_ERRONEOUS_ELEMENT);
export const deleteErroneousElement = createAction(types.DELETE_ERRONEOUS_ELEMENT);
